import {
  Box,
  Button,
  Flex,
  Link,
  Stack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import IconBox from "components/Icons/IconBox";
import { Separator } from "components/Separator/Separator";
import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAllChatsAction } from "../../state/actions/chatActions";

const SidebarContent = ({ logoText, routes }) => {
  let location = useLocation();
  const dispatch = useDispatch();

  const userId = useSelector((state) => state.auth?.user?.user?.user_id);
  const allChats = useSelector((state) => state.chat?.allChats || []);

  React.useEffect(() => {
    dispatch(getAllChatsAction());
    const i = setInterval(() => dispatch(getAllChatsAction()), 10000);
    return () => clearInterval(i);
  }, [dispatch]);

  const messagingCount = React.useMemo(() => {
    if (!userId || !Array.isArray(allChats)) return 0;

    return allChats.filter((chatItem) => {
      const chat = chatItem?.chat || chatItem;

      return (
        chat?.receiver_id === userId &&   
        chat?.sender_id !== userId &&    
        chat?.status === "sent"           
      );
    }).length;
  }, [allChats, userId]);

  const activeRoute = (routeName) => {
    return location.pathname === routeName ? "active" : "";
  };

  const createLinks = (routes) => {
    const activeBg = useColorModeValue("white", "gray.700");
    const activeColor = useColorModeValue("#071D54", "white");
    const inactiveColor = useColorModeValue("white", "gray.400");

    return routes.map((prop) => {
      if (prop.redirect) return null;
      if (prop.category) {
        return (
          <div key={prop.name}>
            <Text
              color={activeColor}
              fontWeight="bold"
              mb={{ xl: "12px" }}
              mx="auto"
              ps={{ sm: "10px", xl: "16px" }}
              py="12px"
            >
              {document.documentElement.dir === "rtl" ? prop.rtlName : prop.name}
            </Text>
            {createLinks(prop.views)}
          </div>
        );
      }
      if (prop.visible === false) return null;

      const isActive = activeRoute(prop.layout + prop.path) === "active";
      const isMessaging = prop.path === "/messages" && prop.layout === "/admin";
      const badgeValue = isMessaging ? messagingCount : 0;

      return (
        <NavLink to={prop.layout + prop.path} key={prop.name}>
          <Button
            boxSize="initial"
            justifyContent="space-between"
            alignItems="center"
            bg={isActive ? activeBg : "transparent"}
            mb={{ xl: "12px" }}
            mx={{ xl: "auto" }}
            py="12px"
            ps={{ sm: "10px", xl: "16px" }}
            pe={{ sm: "10px", xl: "16px" }}
            borderRadius="15px"
            w="100%"
            _hover={isActive ? {} : { bg: "#1E3A8A", color: "white" }}
            _active={{
              bg: "inherit",
              transform: "none",
              borderColor: "transparent",
            }}
            _focus={{ boxShadow: "none" }}
          >
            <Flex align="center">
              <IconBox
                color={isActive ? "#071D54" : "white"}
                h="30px"
                w="30px"
                me="12px"
              >
                {prop.icon}
              </IconBox>
              <Text
                color={isActive ? activeColor : inactiveColor}
                my="auto"
                fontSize="sm"
              >
                {document.documentElement.dir === "rtl" ? prop.rtlName : prop.name}
              </Text>
            </Flex>

            {isMessaging && badgeValue > 0 && (
              <Box
                bg="red.500"
                color="white"
                borderRadius="full"
                minW="20px"
                h="20px"
                px="6px"
                display="flex"
                alignItems="center"
                justifyContent="center"
                fontSize="xs"
              >
                {badgeValue}
              </Box>
            )}
          </Button>
        </NavLink>
      );
    });
  };

  return (
    <>
      <Box pt={"25px"} mb="12px">
        <Link
          href={`${process.env.PUBLIC_URL}/#/`}
          target="_blank"
          display="flex"
          lineHeight="100%"
          mb="30px"
          fontWeight="bold"
          justifyContent="center"
          alignItems="center"
          fontSize="15px"
        >
          <Text fontSize="sm" mt="3px">
            {logoText}
          </Text>
        </Link>
        <Separator />
      </Box>
      <Stack direction="column" mb="40px">
        <Box>{createLinks(routes)}</Box>
      </Stack>
      <Box mt="auto" mb="20px" />
    </>
  );
};

export default SidebarContent;
